import { render } from "./_ChatMap.vue?vue&type=template&id=2fe420fc&scoped=true"
import script from "./_ChatMap.vue?vue&type=script&lang=js"
export * from "./_ChatMap.vue?vue&type=script&lang=js"

import "./_ChatMap.vue?vue&type=style&index=0&id=2fe420fc&lang=scss&scoped=true"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe420fc"]])

export default __exports__